<template>
  <!-- 危废处理模块 -->
  <div class="active_table">
    <toolbar>
      <div class="search">
        <div class="label">选择站点：</div>
        <Select
          v-model="search.siteId"
          style="width: 7.8em"
          @on-change="selectDevice($event)"
          placeholder="请选择设备"
          clearable
        >
          <Option v-for="item in siteList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <div class="label" style="margin-left: 10px">选择设备：</div>
        <Select v-model="search.siteDeviceId" style="width: 7.8em;" placeholder="请选择设备" clearable>
          <Option v-for="item in deviceList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page
        :total="table.total"
        show-sizer
        @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)"
        style="text-align:right;margin-top: 1em"
      />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="140">
        <FormItem label="事件名称：" prop="name">
          <i-input v-model="formValidate.name" placeholder="输入事件名称"></i-input>
        </FormItem>
        <FormItem label="站点名称：" prop="siteId">
          <Select
            v-model="formValidate.siteId"
            clearable
            @on-change="selectDevice($event)"
            style="text-align:left"
          >
            <Option v-for="item in siteList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="设备名称：" prop="siteDeviceId">
          <Select v-model="formValidate.siteDeviceId" clearable style="text-align:left">
            <Option v-for="item in deviceList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="事件类型：" prop="type">
          <Select v-model="formValidate.type" clearable style="text-align:left">
            <Option v-for="item in eventType" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="过期时间天数：" prop="endDay">
          <i-input v-model="formValidate.endDay" type="number" placeholder="输入过期天数"></i-input>
        </FormItem>

        <FormItem label="预警倒计天数：" prop="warnDay">
          <i-input v-model="formValidate.warnDay" type="number" placeholder="输入过期天数"></i-input>
        </FormItem>

        <FormItem label="备注：" prop="remark">
          <i-input
            v-model="formValidate.remark"
            type="textarea"
            :autosize="{minRows: 2,maxRows: 5}"
            placeholder="此处写备注"
          ></i-input>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 事件上报表单对话框 -->
    <Modal title="事件上报" v-model="upModal.show" :mask-closable="false">
      <Form :label-width="140">
        <FormItem label="完成时间：">
          <DatePicker type="date" placeholder="选择事件完成时间" v-model="upForm.startTime"></DatePicker>
        </FormItem>
        <FormItem label="上传图片：">
          <LoadImg @close="imgLoadDel" @success="imgLoadSuccess($event)" :imgUrl="upForm.picUrl"></LoadImg>
        </FormItem>
      </Form>
      <div slot="footer">
        <i-button type="primary" @click="reportEvent">上报</i-button>
        <i-button style="margin-left: 1em;" @click="upModal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 事件上报表单对话框 -->
    <Modal title="历史记录" v-model="deiltModal.show" :mask-closable="false">
      <div class="hisContent">
        <ul>
          <li v-if="historyList.length==0">暂无数据</li>
          <li v-for="item in historyList" :key="item.id">
            <div class="img_box">
              <img :src="item.picUrl" alt />
            </div>
            <div>
              <div>
                时间：
                <span>{{ item.createDate }}</span>
              </div>
              <div>
                操作员：
                <span>{{ item.operatorName }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div slot="footer"></div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p
      :modalAlert="alert.show"
      title="警告提醒"
      content="确定要删除吗？"
      @cansel="alert.show=false"
      @makeSure="delData"
      :modal_loading="alert.loading"
    ></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}
.content {
  width: 700px;
  img {
    width: 100%;
  }
}
.hisContent {
  ul {
    li {
      display: flex;
      align-items: center;

      margin-bottom: 0.625em;
      .img_box {
        width: 10em;
        height: 6em;
        overflow: hidden;
        border: 1px solid #ccc;
        border-radius: 0.25em;
        margin-right: 1em;
      }
      img {
        width: 100%;
      }
    }
    li:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import LoadImg from "../../../components/Load_img.vue";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "序号",
            key: "index",
            width: 80,
            align: "center"
          },
          {
            title: "事件名称",
            key: "name",
            align: "center"
          },
          {
            title: "站点名称",
            key: "siteName",
            align: "center"
          },
          {
            title: "设备名称",
            key: "siteDeviceName",
            align: "center"
          },
          {
            title: "事件类型",
            key: "typeName",
            align: "center"
          },
          {
            title: "备注",
            key: "remark",
            align: "center"
          },
          {
            title: "开始时间",
            key: "startTime",
            align: "center",
            render(h, params) {
              return h(
                "span",
                {},
                timeStamp(params.row.startTime, "yyyy-MM-dd")
              );
            }
          },
          {
            title: "剩余天数",
            key: "remainDay",
            align: "center"
          },
          {
            title: "替换周期(天)",
            key: "endDay",
            align: "center"
          },
          {
            title: "预警倒计天数",
            key: "warnDay",
            align: "center"
          },
          {
            title: "危废处理",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "4px"
                    },
                    on: {
                      click: () => {
                        this.upForm.id = params.row.id;
                        this.upModal.show = true;
                        this.upModal.type = params.row.type;
                      }
                    }
                  },
                  "上报处理"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.deiltModal.show = true;
                        // console.log(params.row.id);
                        this.$api.Event.getDeiltData(
                          { content: { id: params.row.id } },
                          ["uuid", "company"]
                        ).then(res => {
                          if (res.code == 0) {
                            let data = res.data.records;
                            for (
                              let i = 0, length = data.length;
                              i < length;
                              i++
                            ) {
                              data[i].createDate = timeStamp(
                                data[i].createDate
                              );
                            }
                            this.historyList = res.data.records;
                          }
                        });
                      }
                    }
                  },
                  "历史记录"
                )
              ]);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.selectDevice(params.row.siteId);
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        setTimeout(() => {
                          this.formValidate = {
                            id: params.row.id,
                            name: params.row.name,
                            remark: params.row.remark,
                            endDay: params.row.endDay,
                            siteId: params.row.siteId,
                            warnDay: params.row.warnDay,
                            siteDeviceId: params.row.siteDeviceId,
                            type: params.row.type
                          };
                        }, 300);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        siteId: null, // 站点id
        siteDeviceId: null // 设备id
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加",
        companyShow: false // 站点工艺图modal显示隐藏
      },
      // 上报事件表单对话框
      upModal: {
        show: false
      },
      // 上报事件表单数据
      upForm: {
        startTime: null,
        picUrl: null,
        id: null
      },
      deiltModal: {
        show: false
      },
      // 表单数据
      formValidate: {
        name: null,
        remark: null,
        warnDay: null,
        endDay: null,
        siteId: null,
        siteDeviceId: null,
        type: null
      },
      // 验证
      ruleValidate: {
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        siteId: [{ required: true, message: "不能为空" }],
        type: [{ required: true, message: "不能为空" }],
        endDay: [{ required: true, message: "不能为空" }],
        warnDay: [{ required: true, message: "不能为空" }],
        siteDeviceId: [{ required: true, message: "不能为空" }]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      // 枚举数据
      siteList: [], // 站点枚举列表
      deviceList: [], // 设备列表
      eventType: [
        {
          name: "危废处理",
          value: "DANGEROUS_WASTE"
        },
        {
          name: "维保类型",
          value: "MAINTENANCE"
        }
      ], // 事件列表
      historyList: []
    };
  },
  components: {
    toolbar,
    LoadImg
  },
  created() {
    this.getData(); // 数据初始化
    this.getSiteEnum();
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {};
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Event.getEventList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          // 给list数组中的每个元素添加index索引字段
          res.data.list.forEach((item, index) => {
            item.index = index + 1;
          });
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Event.postDelEvent({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Event.postAddEvent({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Event.postEditEvent({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        } else {
          this.$Message.warning("输入信息有误");
        }
      });
    },
    // 获取站点枚举值
    getSiteEnum() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取设备
    selectDevice(msg) {
      //console.log(msg);
      if (!msg) {
        return;
      }
      let siteList = this.siteList;
      let site = siteList.filter(res => {
        return res.id == msg;
      });
      this.$api.Enum.getDeviceEnum({ content: { mn: site[0].mn } }, [
        "uuid",
        "company"
      ]).then(res => {
        if (res.code == 0) {
          this.deviceList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取端口对应设备失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 上传成功后的回调
    imgLoadSuccess(e) {
      this.upForm.picUrl = e;
    },
    // 删除上传
    imgLoadDel() {
      this.upForm.picUrl = "";
    },
    // 上报事件
    reportEvent() {
      if (!this.upForm.startTime) {
        this.$Message.warning("请选择事件开始时间");
        return;
      }
      // if (!this.upForm.picUrl && this.upForm.type == "DANGEROUS_WASTE") {
      //   this.$Message.warning("请上传图片");
      //   return;
      // }
      // this.upForm.startTime = new Date(this.upForm.startTime).getTime();
      this.$api.Event.postEditEventDate({ content: this.upForm }, [
        "uuid",
        "company"
      ]).then(res => {
        if (res.code == 0) {
          this.upModal.show = false;
          this.$Notice.success({
            title: "上报成功",
            desc: "已经上报完成"
          });
        } else {
          this.$Notice.warning({
            title: "上报失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    }
  }
};
</script>